import React, { Component } from "react";
import PropTypes from "prop-types";
import { Placeholder } from "../ui";
import { v4 as uuidV4 } from "uuid";

export default class Frame extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    title: PropTypes.string.isRequired,
    content: PropTypes.string
  };

  render() {
    let sizes = [90, 80, 70, 90, 80, 50, 70, 90, 80, 50, 90, 80, 70, 90];

    if (this.props.loading) {
      return (
        <div>
          <div style={{ paddingBottom: 24, textAlign: "center" }}>
            <Placeholder opacity={50} width={50} height={24} />
          </div>

          {[...sizes, ...sizes, ...sizes, ...sizes].map(i => {
            return (
              <div key={`placeholder-${uuidV4()}`} style={{ paddingBottom: 8 }}>
                <Placeholder opacity={40} width={i} height={8} />
              </div>
            );
          })}
        </div>
      );
    } else {
      return (
        <iframe
          title={this.props.title}
          srcDoc={this.props.content}
          width="100%"
          height="100%"
        ></iframe>
      );
    }
  }
}
